import React from 'react';
import {
  House, Buildings, Door, Tree, Storefront, Briefcase, Suitcase,
  Warehouse, Lock, Laptop, DeviceMobile, DeviceTablet,
  GameController, Camera, Headphones, Cpu, WifiHigh, Plug, Desktop,
  TShirt, Sneaker, Handbag, Watch, Diamond, Package, Eyeglasses,
  Palette, Car, Motorcycle, Truck, Van, Gear, Hammer, Circle, Wrench,
  ForkKnife, Bed, Plant, Barbell, Book, Guitar, Lightbulb,
  Broom, HardHat, GraduationCap, Champagne, Drop, Code, Scales,
  Handshake, PaintBrush, Bicycle, Couch, Football, Toolbox
} from '@phosphor-icons/react';

const iconMap = {
  // FontAwesome icon names (used in database)
  'FaCar': Car,
  'FaHome': House,
  'FaMobileAlt': DeviceMobile,
  'FaTshirt': TShirt,
  'FaFutbol': Football,
  'FaCouch': Couch,
  'FaTools': Toolbox,
  'FaBriefcase': Briefcase,
  'FaUtensils': ForkKnife,
  'FaBook': Book,
  
  // Phosphor icon names
  'house': House,
  'home': House,
  'building': Buildings,
  'buildings': Buildings,
  'door-open': Door,
  'door': Door,
  'tree': Tree,
  'plant': Plant,
  'store': Storefront,
  'storefront': Storefront,
  'briefcase': Briefcase,
  'luggage': Suitcase,
  'suitcase': Suitcase,
  'parking': Circle,
  'warehouse': Warehouse,
  'building-lock': Lock,
  'lock': Lock,
  'laptop': Laptop,
  'smartphone': DeviceMobile,
  'device-mobile': DeviceMobile,
  'tablet': DeviceTablet,
  'device-tablet': DeviceTablet,
  'gamepad': GameController,
  'game-controller': GameController,
  'camera': Camera,
  'headphones': Headphones,
  'chip': Cpu,
  'cpu': Cpu,
  'wifi': WifiHigh,
  'wifi-high': WifiHigh,
  'plug': Plug,
  'desktop': Desktop,
  'monitor': Desktop,
  'tshirt': TShirt,
  'shoe': Sneaker,
  'sneaker': Sneaker,
  'bag': Handbag,
  'handbag': Handbag,
  'watch': Watch,
  'ring': Diamond,
  'diamond': Diamond,
  'belt': Package,
  'glasses': Eyeglasses,
  'eyeglasses': Eyeglasses,
  'hat': Package,
  'scarf': Package,
  'palette': Palette,
  'car': Car,
  'motorcycle': Motorcycle,
  'truck': Truck,
  'van': Van,
  'cog': Gear,
  'gear': Gear,
  'hammer': Hammer,
  'tire': Circle,
  'circle': Circle,
  'wrench': Wrench,
  'bicycle': Bicycle,
  'bike': Bicycle,
  'screwdriver': Gear,
  'couch': Couch,
  'sofa': Couch,
  'paint-brush': PaintBrush,
  'paintbrush': PaintBrush,
  'utensils': ForkKnife,
  'fork-knife': ForkKnife,
  'bed': Bed,
  'leaf': Plant,
  'dumbbell': Barbell,
  'barbell': Barbell,
  'dice': Package,
  'package': Package,
  'book': Book,
  'guitar': Guitar,
  'lightbulb': Lightbulb,
  'broom': Broom,
  'hard-hat': HardHat,
  'hardhat': HardHat,
  'graduation-cap': GraduationCap,
  'champagne': Champagne,
  'spa': Drop,
  'drop': Drop,
  'droplet': Drop,
  'code': Code,
  'truck-delivery': Truck,
  'gavel': Scales,
  'scales': Scales,
  'camera-retro': Camera,
  'handshake': Handshake
};

// Colores de gradiente por categoría
// eslint-disable-next-line no-unused-vars
const categoryColors = {
  // Real Estate
  'house': ['#667eea', '#764ba2'],
  'buildings': ['#667eea', '#764ba2'],
  'door': ['#667eea', '#764ba2'],
  'tree': ['#667eea', '#764ba2'],
  'storefront': ['#667eea', '#764ba2'],
  'suitcase': ['#667eea', '#764ba2'],
  'warehouse': ['#667eea', '#764ba2'],
  'lock': ['#667eea', '#764ba2'],
  
  // Electronics
  'laptop': ['#4facfe', '#00f2fe'],
  'device-mobile': ['#4facfe', '#00f2fe'],
  'device-tablet': ['#4facfe', '#00f2fe'],
  'game-controller': ['#4facfe', '#00f2fe'],
  'camera': ['#4facfe', '#00f2fe'],
  'headphones': ['#4facfe', '#00f2fe'],
  'cpu': ['#4facfe', '#00f2fe'],
  'wifi-high': ['#4facfe', '#00f2fe'],
  'plug': ['#4facfe', '#00f2fe'],
  'desktop': ['#4facfe', '#00f2fe'],
  
  // Fashion
  'tshirt': ['#f093fb', '#f5576c'],
  'sneaker': ['#f093fb', '#f5576c'],
  'handbag': ['#f093fb', '#f5576c'],
  'watch': ['#f093fb', '#f5576c'],
  'diamond': ['#f093fb', '#f5576c'],
  'package': ['#f093fb', '#f5576c'],
  'eyeglasses': ['#f093fb', '#f5576c'],
  'palette': ['#f093fb', '#f5576c'],
  
  // Motor
  'car': ['#fa709a', '#fee140'],
  'motorcycle': ['#fa709a', '#fee140'],
  'truck': ['#fa709a', '#fee140'],
  'van': ['#fa709a', '#fee140'],
  'gear': ['#fa709a', '#fee140'],
  'hammer': ['#fa709a', '#fee140'],
  'circle': ['#fa709a', '#fee140'],
  'wrench': ['#fa709a', '#fee140'],
  'bicycle': ['#fa709a', '#fee140'],
  
  // Home & Garden
  'couch': ['#43e97b', '#38f9d7'],
  'paintbrush': ['#43e97b', '#38f9d7'],
  'fork-knife': ['#43e97b', '#38f9d7'],
  'bed': ['#43e97b', '#38f9d7'],
  'plant': ['#43e97b', '#38f9d7'],
  'barbell': ['#43e97b', '#38f9d7'],
  'book': ['#43e97b', '#38f9d7'],
  'guitar': ['#43e97b', '#38f9d7'],
  'lightbulb': ['#43e97b', '#38f9d7'],
  
  // Services
  'briefcase': ['#fa8bff', '#2bd2ff'],
  'broom': ['#fa8bff', '#2bd2ff'],
  'hardhat': ['#fa8bff', '#2bd2ff'],
  'graduation-cap': ['#fa8bff', '#2bd2ff'],
  'champagne': ['#fa8bff', '#2bd2ff'],
  'drop': ['#fa8bff', '#2bd2ff'],
  'code': ['#fa8bff', '#2bd2ff'],
  'scales': ['#fa8bff', '#2bd2ff'],
  'handshake': ['#fa8bff', '#2bd2ff'],
};

const CategoryIcon = ({ icon, size = 24, color, className = '', style = {}, categoryId, ...props }) => {
  const IconComponent = iconMap[icon] || House;
  
  // Determinar el color basado en el categoryId
  // 1: Vehicles (100-110)
  // 2: Property (200-210)
  // 3: Electronics (300-310)
  // 4: Fashion & Beauty (400-410)
  // 5: Hobbies & Sports (500-510)
  // 6: Home & Living (600-610)
  // 7: Services (700-710)
  // 8: Jobs (800-810)
  // 9: Food & Beverages (900-910)
  // 10: Education & Books (1000-1010)
  
  let categoryColor = '245, 158, 11'; // default orange (vehicles)
  
  if (categoryId) {
    if (categoryId === 1 || (categoryId >= 101 && categoryId <= 110)) {
      categoryColor = '245, 158, 11'; // Vehicles - orange
    } else if (categoryId === 2 || (categoryId >= 201 && categoryId <= 210)) {
      categoryColor = '139, 92, 246'; // Property - purple
    } else if (categoryId === 3 || (categoryId >= 301 && categoryId <= 310)) {
      categoryColor = '59, 130, 246'; // Electronics - blue
    } else if (categoryId === 4 || (categoryId >= 401 && categoryId <= 410)) {
      categoryColor = '236, 72, 153'; // Fashion & Beauty - pink
    } else if (categoryId === 5 || (categoryId >= 501 && categoryId <= 510)) {
      categoryColor = '34, 197, 94'; // Hobbies & Sports - green
    } else if (categoryId === 6 || (categoryId >= 601 && categoryId <= 610)) {
      categoryColor = '16, 185, 129'; // Home & Living - emerald
    } else if (categoryId === 7 || (categoryId >= 701 && categoryId <= 710)) {
      categoryColor = '6, 182, 212'; // Services - cyan
    } else if (categoryId === 8 || (categoryId >= 801 && categoryId <= 810)) {
      categoryColor = '99, 102, 241'; // Jobs - indigo
    } else if (categoryId === 9 || (categoryId >= 901 && categoryId <= 910)) {
      categoryColor = '239, 68, 68'; // Food & Beverages - red
    } else if (categoryId === 10 || (categoryId >= 1001 && categoryId <= 1010)) {
      categoryColor = '168, 85, 247'; // Education & Books - violet
    }
  }
  
  // Colores sólidos más brillantes para los iconos
  const iconColorMap = {
    '245, 158, 11': '#fbbf24',     // amber-400 - Vehicles
    '139, 92, 246': '#a78bfa',     // purple-400 - Property
    '59, 130, 246': '#60a5fa',     // blue-400 - Electronics
    '236, 72, 153': '#f472b6',     // pink-400 - Fashion & Beauty
    '34, 197, 94': '#4ade80',      // green-400 - Hobbies & Sports
    '16, 185, 129': '#34d399',     // emerald-400 - Home & Living
    '6, 182, 212': '#22d3ee',      // cyan-400 - Services
    '99, 102, 241': '#818cf8',     // indigo-400 - Jobs
    '239, 68, 68': '#f87171',      // red-400 - Food & Beverages
    '168, 85, 247': '#c084fc',     // violet-400 - Education & Books
  };
  
  const iconColor = iconColorMap[categoryColor] || '#fbbf24';
  
  // Wrapper con fondo degradado suave - tamaño ajustable basado en el size del icono
  const boxSize = size * 1.75; // El contenedor es 1.75 veces el tamaño del icono
  const wrapperStyle = {
    width: `${boxSize}px`,
    height: `${boxSize}px`,
    borderRadius: '12px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(135deg, rgba(${categoryColor}, 0.2), rgba(${categoryColor}, 0.05))`,
    ...style
  };
  
  return (
    <div style={wrapperStyle} className={className}>
      <IconComponent 
        size={size}
        weight="bold"
        color={iconColor}
        {...props}
      />
    </div>
  );
};

export default CategoryIcon;
